<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { staticClass: "info", class: { disabledInfo: !_vm.isEditable } },
    [
      _c("validation-observer", {
        ref: "personalInformation",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var invalid = ref.invalid
              return [
                _c(
                  "b-form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.personalInformation($event)
                      },
                    },
                  },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { staticClass: "mobile-100", attrs: { cols: "6" } },
                          [
                            _c("div", { staticClass: "bold-page-title" }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("Kyc.Personal-Information")) +
                                  " "
                              ),
                            ]),
                            _c("div", { staticClass: "btm-info" }, [
                              _c("div", { staticClass: "desc-innformationn" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.$t("Kyc.Provide-Id")) + " "
                                ),
                              ]),
                            ]),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "bv-no-focus-ring col-form-label pt-0",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("Kyc.Country")) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "red-star" },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _c("CountrySelect", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Country"),
                                            placeholder: _vm.$t(
                                              "register.countryPlaceholder"
                                            ),
                                            clearable: false,
                                            disabled: true,
                                            reduce: "id",
                                          },
                                          model: {
                                            value: _vm.country,
                                            callback: function ($$v) {
                                              _vm.country = $$v
                                            },
                                            expression: "country",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("Kyc.Full-Name"),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("Kyc.Full-Name")
                                                      ) + " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "red-star",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Full-Name"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        name: _vm.$t(
                                                          "Kyc.Full-Name"
                                                        ),
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.fullName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.fullName = $$v
                                                        },
                                                        expression: "fullName",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "bv-no-focus-ring col-form-label pt-0",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Kyc.Date-Of-Birth")
                                              ) + " "
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "red-star" },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Date-Of-Birth"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("DatePicker", {
                                                      attrs: {
                                                        maxDate: new Date(),
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                        isEditable:
                                                          _vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.dob,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.dob = $$v
                                                        },
                                                        expression: "dob",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error:
                                                          errors[0] ||
                                                          _vm.minAgeError,
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: { label: _vm.$t("Kyc.Address") },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("Kyc.Address")
                                                      ) + " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "red-star",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Address"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        state:
                                                          errors.length > 0
                                                            ? false
                                                            : null,
                                                        type: "text",
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.address,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.address = $$v
                                                        },
                                                        expression: "address",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mobile-100",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "bv-no-focus-ring col-form-label pt-0",
                                          },
                                          [
                                            _vm._v(_vm._s(_vm.$t("Kyc.State"))),
                                            _c(
                                              "span",
                                              { staticClass: "red-star" },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.State"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-select", {
                                                      attrs: {
                                                        label: "stateName",
                                                        options:
                                                          _vm.refData
                                                            .countryData
                                                            .countryStates ||
                                                          [],
                                                        reduce: function (
                                                          option
                                                        ) {
                                                          return option.stateCode
                                                        },
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.state,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.state = $$v
                                                        },
                                                        expression: "state",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mobile-100",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: { label: _vm.$t("Kyc.City") },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("Kyc.City")
                                                      ) + " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "red-star",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.City"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.city,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.city = $$v
                                                        },
                                                        expression: "city",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("Kyc.Zip-Code"),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t("Kyc.Zip-Code")
                                                      ) + " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "red-star",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Zip-Code"),
                                            rules: "required|min:2|max:10",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "number",
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.zipCode,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.zipCode = $$v
                                                        },
                                                        expression: "zipCode",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { staticClass: "mobile-100", attrs: { cols: "6" } },
                          [
                            _c("div", { staticClass: "bold-page-title" }, [
                              _vm._v(_vm._s(_vm.$t("Kyc.Upload-Document"))),
                            ]),
                            _c("div", { staticClass: "btm-info" }, [
                              _c("div", { staticClass: "desc-innfor-bold" }, [
                                _c("span"),
                                _vm._v(
                                  _vm._s(_vm.$t("Kyc.Bright-And-Clear")) + " "
                                ),
                              ]),
                              _c("div", { staticClass: "desc-innfor-bold" }, [
                                _c("span"),
                                _vm._v(
                                  _vm._s(_vm.$t("Kyc.All-Corners-Visible")) +
                                    " "
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "kyc-img-row" }, [
                              _c(
                                "div",
                                { staticClass: "kyc-upload" },
                                [_c("KycOne")],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "kyc-upload" },
                                [_c("KycTwo")],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "kyc-upload" },
                                [_c("KycThree")],
                                1
                              ),
                            ]),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  { attrs: { cols: "12" } },
                                  [
                                    _c(
                                      "b-form-group",
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "bv-no-focus-ring col-form-label pt-0",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("Kyc.Document-Type")
                                              )
                                            ),
                                            _c(
                                              "span",
                                              { staticClass: "red-star" },
                                              [_vm._v("*")]
                                            ),
                                          ]
                                        ),
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Document-Type"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("v-select", {
                                                      attrs: {
                                                        options:
                                                          _vm.refData
                                                            .countryData.kyc
                                                            .identificationTypes ||
                                                          [],
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.documentType,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.documentType = $$v
                                                        },
                                                        expression:
                                                          "documentType",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.documentType,
                                        expression: "documentType",
                                      },
                                    ],
                                    attrs: { cols: "12" },
                                  },
                                  [
                                    _c(
                                      "b-form-group",
                                      {
                                        attrs: {
                                          label: _vm.$t("Kyc.Aadhaar-No", {
                                            document: _vm.documentType,
                                          }),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "label",
                                              fn: function () {
                                                return [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "Kyc.Aadhaar-No",
                                                          {
                                                            document:
                                                              _vm.documentType,
                                                          }
                                                        )
                                                      ) + " "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "red-star",
                                                      },
                                                      [_vm._v("*")]
                                                    ),
                                                  ]),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      },
                                      [
                                        _c("validation-provider", {
                                          attrs: {
                                            name: _vm.$t("Kyc.Aadhaar-No"),
                                            rules: "required",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var errors = ref.errors
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: {
                                                        type: "text",
                                                        disabled:
                                                          !_vm.isEditable,
                                                      },
                                                      model: {
                                                        value: _vm.documentNo,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.documentNo = $$v
                                                        },
                                                        expression:
                                                          "documentNo",
                                                      },
                                                    }),
                                                    _c("Errors", {
                                                      attrs: {
                                                        error: errors[0],
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              { staticClass: "upload-section" },
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mobile-100 error-outer",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c("div", { staticClass: "upload-txt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Kyc.Upload-The")) +
                                          " "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("Kyc.Document-Front"))
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Kyc.Document")) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "red-star" }, [
                                        _vm._v("*"),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-upload pay-upload p-none",
                                        attrs: { disabled: !_vm.isEditable },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleImage({
                                              imageKey: "front",
                                              showCameraPop: true,
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "img-upload" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.imageSrc
                                                  ? "img-scr"
                                                  : "",
                                              },
                                              [
                                                _vm.imageSrc
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reupload-class",
                                                          },
                                                          [_c("Reupload")],
                                                          1
                                                        ),
                                                        _c("b-img", {
                                                          staticClass: "camera",
                                                          staticStyle: {
                                                            "max-width": "100%",
                                                          },
                                                          attrs: {
                                                            src: _vm.imageSrc,
                                                            alt: _vm.$t(
                                                              "Kyc.frontImage"
                                                            ),
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      [
                                                        _c("Upload", {
                                                          staticClass:
                                                            "upload-img-pick",
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("Errors", {
                                      attrs: { error: _vm.frontImgError },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mobile-100 error-outer",
                                    attrs: { cols: "6" },
                                  },
                                  [
                                    _c("div", { staticClass: "upload-txt" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Kyc.Upload-The")) +
                                          " "
                                      ),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("Kyc.Document-Back"))
                                        ),
                                      ]),
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm.$t("Kyc.Document")) +
                                          " "
                                      ),
                                      _c("span", { staticClass: "red-star" }, [
                                        _vm._v("*"),
                                      ]),
                                    ]),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "custom-upload pay-upload p-none",
                                        attrs: { disabled: !_vm.isEditable },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleImage({
                                              imageKey: "back",
                                              showCameraPop: true,
                                            })
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "img-upload" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class: _vm.backImageSrc
                                                  ? "img-scr"
                                                  : "",
                                              },
                                              [
                                                _vm.backImageSrc
                                                  ? _c(
                                                      "div",
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "reupload-class",
                                                          },
                                                          [_c("Reupload")],
                                                          1
                                                        ),
                                                        _c("b-img", {
                                                          staticClass: "camera",
                                                          staticStyle: {
                                                            "max-width": "100%",
                                                          },
                                                          attrs: {
                                                            src: _vm.backImageSrc,
                                                            alt: "Selected Document",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _c(
                                                      "div",
                                                      [
                                                        _c("Upload", {
                                                          staticClass:
                                                            "upload-img-pick",
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c("Errors", {
                                      attrs: { error: _vm.backImgError },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-row",
                              [
                                _c("b-col", { attrs: { cols: "12" } }, [
                                  _c(
                                    "div",
                                    { staticClass: "right-align-btn" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            type: "submit",
                                            variant: "primary",
                                            disabled:
                                              (_vm.isEditable && invalid) ||
                                              _vm.isLoading ||
                                              !_vm.imageSrc ||
                                              !_vm.backImageSrc ||
                                              !!_vm.minAgeError,
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("Kyc.Continue")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm.showCameraPop
        ? _c("WebCam", {
            attrs: {
              showCameraPop: _vm.showCameraPop,
              hideBtns: false,
              toggleImage: _vm.toggleImage,
              imageKey: _vm.imageKey,
              saveImage: _vm.saveImage,
              documentText: _vm.documentType || "",
              Title: "WebCam.CaptureDocument",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/views/kyc/PersonalInformation.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import * as bootstrapvue from 'bootstrap-vue';
import vue_select from 'vue-select';
import assets_rashi_coin_kyc_1_svg from '@/assets/rashi-coin/kyc-1.svg';
import assets_rashi_coin_kyc_2_svg from '@/assets/rashi-coin/kyc-2.svg';
import assets_rashi_coin_kyc_3_svg from '@/assets/rashi-coin/kyc-3.svg';
import assets_rashi_coin_upload_svg from '@/assets/rashi-coin/upload.svg';
import assets_rashi_coin_upload_icon_svg from '@/assets/rashi-coin/upload_icon.svg';
import layouts_components_CountrySelect_vue from '@/layouts/components/CountrySelect.vue';
import layouts_components_DatePicker_vue from '@/layouts/components/DatePicker.vue';
import * as veevalidate from 'vee-validate';
import validations from '@validations';
import layouts_components_WebCam_vue from '@/layouts/components/WebCam.vue';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import * as vuex from 'vuex';
import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

















export default ({
  render,
  staticRenderFns,
  components: {
    KycOne: assets_rashi_coin_kyc_1_svg,
    KycTwo: assets_rashi_coin_kyc_2_svg,
    KycThree: assets_rashi_coin_kyc_3_svg,
    BCard: bootstrapvue["BCard"],
    BRow: bootstrapvue["BRow"],
    BCol: bootstrapvue["BCol"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    BFormCheckbox: bootstrapvue["BFormCheckbox"],
    BForm: bootstrapvue["BForm"],
    BButton: bootstrapvue["BButton"],
    vSelect: vue_select,
    BFormFile: bootstrapvue["BFormFile"],
    Upload: assets_rashi_coin_upload_svg,
    CountrySelect: layouts_components_CountrySelect_vue,
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    BImg: bootstrapvue["BImg"],
    WebCam: layouts_components_WebCam_vue,
    Reupload: assets_rashi_coin_upload_icon_svg,
    DatePicker: layouts_components_DatePicker_vue,
    Errors: layouts_components_Errors_vue
  },
  data() {
    return {
      country: "IN",
      fullName: "",
      address: "",
      lang: this.$route.params.lang,
      isLoading: false,
      state: null,
      city: null,
      zipCode: null,
      documentType: null,
      documentNo: null,
      documentFront: null,
      documentBack: null,
      imageSrc: null,
      backImageSrc: null,
      required: validations["required"],
      dob: null,
      selected: {
        title: "Square"
      },
      option: [{
        title: "Square"
      }, {
        title: "Rectangle"
      }, {
        title: "Rombo"
      }, {
        title: "Romboid"
      }],
      showCameraPop: false,
      imageKey: null,
      backImgError: "",
      frontImgError: "",
      minAgeError: "",
      isEditable: true
    };
  },
  computed: {
    ...vuex.mapState("user", ["refData"])
  },
  mounted() {
    this.getKYCDetail();
  },
  watch: {
    dob(newValue, oldValue) {
      if (newValue != oldValue) {
        // Check if the user is above the minimum age
        const today = new Date();
        const birthDate = new Date(newValue);
        const age = today.getFullYear() - birthDate.getFullYear();
        if (age < this.refData.countryData.kyc.minAge) {
          // Handle the case where the user is below 18
          this.minAgeError = this.$t("Errors.minAge", {
            minAge: this.refData.countryData.kyc.minAge
          });
        } else {
          this.minAgeError = null;
        }
      }
    }
  },
  methods: {
    toggleImage(props) {
      if (this.isEditable) {
        if (!props.showCameraPop) {
          this.imageKey = "";
          this.validateImg();
        } else {
          this.imageKey = props.imageKey;
        }
        this.showCameraPop = props.showCameraPop;
      }
    },
    saveImage(file, picture, imageKey) {
      if (file && picture) {
        if (imageKey === "front") {
          this.imageSrc = picture;
          this.documentFront = file;
          if (!file) {}
        } else if (imageKey === "back") {
          this.backImageSrc = picture;
          this.documentBack = file;
        }
      }
    },
    handleFileSelected() {
      // Convert the selected File to a data URL
      if (this.documentFront) {
        const reader = new FileReader();
        reader.onload = event => {
          this.imageSrc = event.target.result;
        };
        reader.readAsDataURL(this.documentFront);
      }
    },
    validateImg() {
      if (!this.imageSrc || !this.backImageSrc) {
        if (!this.imageSrc) {
          this.frontImgError = this.$t("Errors.frontImageRequired");
        } else {
          this.frontImgError = "";
        }
        if (!this.backImageSrc) {
          this.backImgError = this.$t("Errors.backImageRequired");
        } else {
          this.backImgError = "";
        }
        return false;
      } else {
        this.frontImgError = "";
        this.backImgError = "";
      }
      return true;
    },
    async personalInformation() {
      if (this.isEditable) {
        if (!this.validateImg()) {
          return;
        }
        this.saveKYCDetail();
      } else {
        if (this.refData.countryData.kyc.verificationTypes.length === 2) {
          this.$router.push({
            name: "selfie-verification",
            params: {
              lang: this.lang || undefined
            }
          });
        } else if (this.refData.countryData.kyc.verificationTypes.length >= 3) this.$router.push({
          name: "pan-verification",
          params: {
            lang: this.lang || undefined
          }
        });
      }
    },
    async getKYCDetail() {
      try {
        this.isLoading = true;
        const res = await new libs_api_api().api({
          method: "GET",
          url: `kyc/details`
        }, {}, {
          isLoading: true
        });
        if (res && res.verificationDetails && res.verificationDetails.info && res.verificationDetails.info.identification) {
          const identification = res.verificationDetails.info.identification;
          this.country = identification.countryCode;
          this.fullName = identification.fullName;
          this.address = identification.address;
          this.state = identification.stateCode;
          this.city = identification.city;
          this.zipCode = identification.zipCode;
          this.documentType = identification.docType;
          this.documentNo = identification.docNumber;
          this.imageSrc = identification.frontDocUrl;
          this.backImageSrc = identification.backDocUrl;
          this.dob = identification.birthDate;
          const allowedStatusValues = ["SUBMITTED", "PENDING", "APPROVED", "DISAPPROVED"];
          if (allowedStatusValues.includes(identification.verificationStatus)) {
            this.isEditable = false;
          }
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    },
    async saveKYCDetail() {
      try {
        this.isLoading = true;
        const formData = new FormData();
        formData.append("verificationType", "IDENTIFICATION");
        formData.append("id.fullName", this.fullName);
        formData.append("id.birthDate", this.dob);
        formData.append("id.address", this.address);
        formData.append("id.city", this.city);
        formData.append("id.zipCode", this.zipCode);
        formData.append("id.stateCode", this.state);
        formData.append("id.countryCode", this.country);
        formData.append("id.docType", this.documentType);
        formData.append("id.docNumber", this.documentNo);
        this.documentFront && formData.append("id.frontDoc", this.documentFront);
        this.documentBack && formData.append("id.backDoc", this.documentBack);
        const res = await new libs_api_api().api({
          method: "POST",
          url: `kyc/save`
        }, formData, {
          isLoading: true
        });
        if (res && res.result && res.result.requestStatus == "SUCCESS") {
          this.$router.push({
            name: "pan-verification",
            params: {
              lang: this.lang || undefined
            }
          });
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
      this.isLoading = false;
    }
  }
});

//# sourceURL=webpack:///./src/views/kyc/PersonalInformation.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

<style>
.v-select {
  position: relative;
  font-family: inherit;
}
.v-select,
.v-select * {
  box-sizing: border-box;
}

/* KeyFrames */
@-webkit-keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@-webkit-keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
@keyframes vSelectSpinner-ltr {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(360deg);
}
}
@keyframes vSelectSpinner-rtl {
0% {
    transform: rotate(0deg);
}
100% {
    transform: rotate(-360deg);
}
}
/* Dropdown Default Transition */
.vs__fade-enter-active,
.vs__fade-leave-active {
  pointer-events: none;
  transition: opacity 0.15s cubic-bezier(1, 0.5, 0.8, 1);
}
.vs__fade-enter,
.vs__fade-leave-to {
  opacity: 0;
}

/** Component States */
/*
 * Disabled
 *
 * When the component is disabled, all interaction
 * should be prevented. Here we modify the bg color,
 * and change the cursor displayed on the interactive
 * components.
 */
[dir] .vs--disabled .vs__dropdown-toggle, [dir] .vs--disabled .vs__clear, [dir] .vs--disabled .vs__search, [dir] .vs--disabled .vs__selected, [dir] .vs--disabled .vs__open-indicator {
  cursor: not-allowed;
  background-color: #f8f8f8;
}

/*
 *  RTL - Right to Left Support
 *
 *  Because we're using a flexbox layout, the `dir="rtl"`
 *  HTML attribute does most of the work for us by
 *  rearranging the child elements visually.
 */
.v-select[dir=rtl] .vs__actions {
  padding: 0 3px 0 6px;
}
.v-select[dir=rtl] .vs__clear {
  margin-left: 6px;
  margin-right: 0;
}
.v-select[dir=rtl] .vs__deselect {
  margin-left: 0;
  margin-right: 2px;
}
.v-select[dir=rtl] .vs__dropdown-menu {
  text-align: right;
}

/**
    Dropdown Toggle

    The dropdown toggle is the primary wrapper of the component. It
    has two direct descendants: .vs__selected-options, and .vs__actions.

    .vs__selected-options holds the .vs__selected's as well as the
    main search input.

    .vs__actions holds the clear button and dropdown toggle.
 */
.vs__dropdown-toggle {
  appearance: none;
  display: flex;
  white-space: normal;
}
[dir] .vs__dropdown-toggle {
  padding: 0 0 4px 0;
  background: none;
  border: 1px solid #d8d6de;
  border-radius: 0.357rem;
}
.vs__selected-options {
  display: flex;
  flex-basis: 100%;
  flex-grow: 1;
  flex-wrap: wrap;
  position: relative;
}
[dir] .vs__selected-options {
  padding: 0 2px;
}
.vs__actions {
  display: flex;
  align-items: center;
}
[dir=ltr] .vs__actions {
  padding: 4px 6px 0 3px;
}
[dir=rtl] .vs__actions {
  padding: 4px 3px 0 6px;
}

/* Dropdown Toggle States */
[dir] .vs--searchable .vs__dropdown-toggle {
  cursor: text;
}
[dir] .vs--unsearchable .vs__dropdown-toggle {
  cursor: pointer;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-bottom-color: transparent;
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.vs__open-indicator {
  fill: rgba(60, 60, 60, 0.5);
  transition: transform 150ms cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir] .vs__open-indicator {
  transform: scale(1);
  transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}
[dir=ltr] .vs--open .vs__open-indicator {
  transform: rotate(180deg) scale(1);
}
[dir=rtl] .vs--open .vs__open-indicator {
  transform: rotate(-180deg) scale(1);
}
.vs--loading .vs__open-indicator {
  opacity: 0;
}

/* Clear Button */
.vs__clear {
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__clear {
  padding: 0;
  border: 0;
  background-color: transparent;
  cursor: pointer;
}
[dir=ltr] .vs__clear {
  margin-right: 8px;
}
[dir=rtl] .vs__clear {
  margin-left: 8px;
}

/* Dropdown Menu */
.vs__dropdown-menu {
  display: block;
  box-sizing: border-box;
  position: absolute;
  top: calc(100% - 1px);
  z-index: 1000;
  width: 100%;
  max-height: 350px;
  min-width: 160px;
  overflow-y: auto;
  list-style: none;
}
[dir] .vs__dropdown-menu {
  padding: 5px 0;
  margin: 0;
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  border: 1px solid #d8d6de;
  border-top-style: none;
  border-radius: 0 0 0.357rem 0.357rem;
  background: #fff;
}
[dir=ltr] .vs__dropdown-menu {
  left: 0;
  text-align: left;
}
[dir=rtl] .vs__dropdown-menu {
  right: 0;
  text-align: right;
}
[dir] .vs__no-options {
  text-align: center;
}

/* List Items */
.vs__dropdown-option {
  line-height: 1.42857143;
  /* Normalize line height */
  display: block;
  color: #333;
  /* Overrides most CSS frameworks */
  white-space: nowrap;
}
[dir] .vs__dropdown-option {
  padding: 3px 20px;
  clear: both;
}
[dir] .vs__dropdown-option:hover {
  cursor: pointer;
}
.vs__dropdown-option--highlight {
  color: #8dc540 !important;
}
[dir] .vs__dropdown-option--highlight {
  background: rgba(141, 197, 64, 0.12);
}
.vs__dropdown-option--disabled {
  color: rgba(60, 60, 60, 0.5);
}
[dir] .vs__dropdown-option--disabled {
  background: inherit;
}
[dir] .vs__dropdown-option--disabled:hover {
  cursor: inherit;
}

/* Selected Tags */
.vs__selected {
  display: flex;
  align-items: center;
  color: #333;
  line-height: 1.8;
  z-index: 0;
}
[dir] .vs__selected {
  background-color: #8dc540;
  border: 0 solid rgba(60, 60, 60, 0.26);
  border-radius: 0.357rem;
  margin: 4px 2px 0px 2px;
  padding: 0 0.25em;
}
.vs__deselect {
  display: inline-flex;
  appearance: none;
  fill: rgba(60, 60, 60, 0.5);
}
[dir] .vs__deselect {
  padding: 0;
  border: 0;
  cursor: pointer;
  background: none;
  text-shadow: 0 1px 0 #fff;
}
[dir=ltr] .vs__deselect {
  margin-left: 4px;
}
[dir=rtl] .vs__deselect {
  margin-right: 4px;
}

/* States */
[dir] .vs--single .vs__selected {
  background-color: transparent;
  border-color: transparent;
}
.vs--single.vs--open .vs__selected {
  position: absolute;
  opacity: 0.4;
}
.vs--single.vs--searching .vs__selected {
  display: none;
}

/* Search Input */
/**
 * Super weird bug... If this declaration is grouped
 * below, the cancel button will still appear in chrome.
 * If it's up here on it's own, it'll hide it.
 */
.vs__search::-webkit-search-cancel-button {
  display: none;
}
.vs__search::-webkit-search-decoration,
.vs__search::-webkit-search-results-button,
.vs__search::-webkit-search-results-decoration,
.vs__search::-ms-clear {
  display: none;
}
.vs__search,
.vs__search:focus {
  appearance: none;
  line-height: 1.8;
  font-size: 1em;
  outline: none;
  width: 0;
  max-width: 100%;
  flex-grow: 1;
  z-index: 1;
}
[dir] .vs__search, [dir] .vs__search:focus {
  border: 1px solid transparent;
  margin: 4px 0 0 0;
  padding: 0 7px;
  background: none;
  box-shadow: none;
}
[dir=ltr] .vs__search, [dir=ltr] .vs__search:focus {
  border-left: none;
}
[dir=rtl] .vs__search, [dir=rtl] .vs__search:focus {
  border-right: none;
}
.vs__search::placeholder {
  color: #6e6b7b;
}

/**
    States
 */
.vs--unsearchable .vs__search {
  opacity: 1;
}
[dir] .vs--unsearchable:not(.vs--disabled) .vs__search:hover {
  cursor: pointer;
}
.vs--single.vs--searching:not(.vs--open):not(.vs--loading) .vs__search {
  opacity: 0.2;
}

/* Loading Spinner */
.vs__spinner {
  align-self: center;
  opacity: 0;
  font-size: 5px;
  text-indent: -9999em;
  overflow: hidden;
  transition: opacity 0.1s;
}
[dir] .vs__spinner {
  border-top: 0.9em solid rgba(100, 100, 100, 0.1);
  border-bottom: 0.9em solid rgba(100, 100, 100, 0.1);
  transform: translateZ(0);
}
[dir=ltr] .vs__spinner {
  border-right: 0.9em solid rgba(100, 100, 100, 0.1);
  border-left: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-ltr 1.1s infinite linear;
}
[dir=rtl] .vs__spinner {
  border-left: 0.9em solid rgba(100, 100, 100, 0.1);
  border-right: 0.9em solid rgba(60, 60, 60, 0.45);
  animation:  vSelectSpinner-rtl 1.1s infinite linear;
}
.vs__spinner,
.vs__spinner:after {
  width: 5em;
  height: 5em;
}
[dir] .vs__spinner, [dir] .vs__spinner:after {
  border-radius: 50%;
}

/* Loading Spinner States */
.vs--loading .vs__spinner {
  opacity: 1;
}
.vs__open-indicator {
  fill: none;
}
[dir] .vs__open-indicator {
  margin-top: 0.15rem;
}
.vs__dropdown-toggle {
  transition: all 0.25s ease-in-out;
}
[dir] .vs__dropdown-toggle {
  padding: 0.59px 0 4px 0;
}
[dir=ltr] .vs--single .vs__dropdown-toggle {
  padding-left: 6px;
}
[dir=rtl] .vs--single .vs__dropdown-toggle {
  padding-right: 6px;
}
.vs__dropdown-option--disabled {
  opacity: 0.5;
}
[dir] .vs__dropdown-option--disabled.vs__dropdown-option--selected {
  background: #8dc540 !important;
}
.vs__dropdown-option {
  color: #6e6b7b;
}
[dir] .vs__dropdown-option, [dir] .vs__no-options {
  padding: 7px 20px;
}
.vs__dropdown-option--selected {
  background-color: #8dc540;
  color: #fff;
  position: relative;
}
.vs__dropdown-option--selected::after {
  content: "";
  height: 1.1rem;
  width: 1.1rem;
  display: inline-block;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23fff' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-check'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 1.1rem;
}
[dir=rtl] .vs__dropdown-option--selected::after {
  left: 20px;
  right: unset;
}
.vs__dropdown-option--selected.vs__dropdown-option--highlight {
  color: #fff !important;
  background-color: #8dc540 !important;
}
.vs__clear svg {
  color: #6e6b7b;
}
.vs__selected {
  color: #fff;
}
.v-select.vs--single .vs__selected {
  color: #6e6b7b;
  transition: transform 0.2s ease;
}
[dir] .v-select.vs--single .vs__selected {
  margin-top: 5px;
}
[dir=ltr] .v-select.vs--single .vs__selected input {
  padding-left: 0;
}
[dir=rtl] .v-select.vs--single .vs__selected input {
  padding-right: 0;
}
[dir=ltr] .vs--single.vs--open .vs__selected {
  transform: translateX(5px);
}
[dir=rtl] .vs--single.vs--open .vs__selected {
  transform: translateX(-5px);
}
.vs__selected .vs__deselect {
  color: inherit;
}
.v-select:not(.vs--single) .vs__selected {
  font-size: 0.9rem;
}
[dir] .v-select:not(.vs--single) .vs__selected {
  border-radius: 3px;
  padding: 0 0.6em;
}
[dir=ltr] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 2px 2px 5px;
}
[dir=rtl] .v-select:not(.vs--single) .vs__selected {
  margin: 5px 5px 2px 2px;
}
.v-select:not(.vs--single) .vs__deselect svg {
  vertical-align: text-top;
}
[dir] .v-select:not(.vs--single) .vs__deselect svg {
  transform: scale(0.8);
}
.vs__dropdown-menu {
  top: calc(100% + 1rem);
}
[dir] .vs__dropdown-menu {
  border: none;
  border-radius: 6px;
  padding: 0;
}
[dir] .vs--open .vs__dropdown-toggle {
  border-color: #8dc540;
  border-bottom-color: #8dc540;
  box-shadow: 0 3px 10px 0 rgba(34, 41, 47, 0.1);
}
[dir=ltr] .vs--open .vs__dropdown-toggle {
  border-bottom-left-radius: 0.357rem;
  border-bottom-right-radius: 0.357rem;
}
[dir=rtl] .vs--open .vs__dropdown-toggle {
  border-bottom-right-radius: 0.357rem;
  border-bottom-left-radius: 0.357rem;
}
.select-size-lg .vs__selected {
  font-size: 1rem !important;
}
[dir] .select-size-lg.vs--single.vs--open .vs__selected {
  margin-top: 6px;
}
.select-size-lg .vs__dropdown-toggle,
.select-size-lg .vs__selected {
  font-size: 1.25rem;
}
[dir] .select-size-lg .vs__dropdown-toggle {
  padding: 5px;
}
[dir] .select-size-lg .vs__dropdown-toggle input {
  margin-top: 0;
}
.select-size-lg .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-lg .vs__deselect svg {
  transform: scale(1) !important;
}
[dir] .select-size-sm .vs__dropdown-toggle {
  padding-bottom: 0;
  padding: 1px;
}
[dir] .select-size-sm.vs--single .vs__dropdown-toggle {
  padding: 2px;
}
.select-size-sm .vs__dropdown-toggle,
.select-size-sm .vs__selected {
  font-size: 0.9rem;
}
[dir] .select-size-sm .vs__actions {
  padding-top: 2px;
  padding-bottom: 2px;
}
.select-size-sm .vs__deselect svg {
  vertical-align: middle !important;
}
[dir] .select-size-sm .vs__search {
  margin-top: 0;
}
.select-size-sm.v-select .vs__selected {
  font-size: 0.75rem;
}
[dir] .select-size-sm.v-select .vs__selected {
  padding: 0 0.3rem;
}
[dir] .select-size-sm.v-select:not(.vs--single) .vs__selected {
  margin: 4px 5px;
}
[dir] .select-size-sm.v-select.vs--single .vs__selected {
  margin-top: 1px;
}
[dir] .select-size-sm.vs--single.vs--open .vs__selected {
  margin-top: 4px;
}
.dark-layout .vs__dropdown-toggle {
  color: #b4b7bd;
}
[dir] .dark-layout .vs__dropdown-toggle {
  background: #283046;
  border-color: #404656;
}
.dark-layout .vs__selected-options input {
  color: #b4b7bd;
}
.dark-layout .vs__selected-options input::placeholder {
  color: #676d7d;
}
.dark-layout .vs__actions svg {
  fill: #404656;
}
[dir] .dark-layout .vs__dropdown-menu {
  background: #283046;
}
.dark-layout .vs__dropdown-menu li {
  color: #b4b7bd;
}
.dark-layout .v-select:not(.vs--single) .vs__selected {
  color: #8dc540;
}
[dir] .dark-layout .v-select:not(.vs--single) .vs__selected {
  background-color: rgba(141, 197, 64, 0.12);
}
.dark-layout .v-select.vs--single .vs__selected {
  color: #b4b7bd !important;
}
.dark-layout .vs--disabled .vs__dropdown-toggle,
.dark-layout .vs--disabled .vs__clear,
.dark-layout .vs--disabled .vs__search,
.dark-layout .vs--disabled .vs__selected,
.dark-layout .vs--disabled .vs__open-indicator {
  opacity: 0.5;
}
[dir] .dark-layout .vs--disabled .vs__dropdown-toggle, [dir] .dark-layout .vs--disabled .vs__clear, [dir] .dark-layout .vs--disabled .vs__search, [dir] .dark-layout .vs--disabled .vs__selected, [dir] .dark-layout .vs--disabled .vs__open-indicator {
  background-color: #283046;
}
</style>
